import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const stack: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2.5),
});

export const dangerCard: SxProps<Theme> = (theme) => ({
  border: 1.5,
  borderColor: alpha(theme.palette.error.main, 0.35),
  bgcolor: alpha(theme.palette.error.main, 0.04),
  borderRadius: 2,
  p: { xs: 2, md: 2.5 },
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
});

export const dangerHeader: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
});

export const statusChip =
  (active: boolean): SxProps<Theme> =>
  (theme) => {
    const color = active ? theme.palette.success.main : theme.palette.text.secondary;
    return {
      flex: "none",
      px: 1.25,
      py: 0.25,
      borderRadius: 999,
      fontSize: "0.6875rem",
      fontWeight: 700,
      color,
      bgcolor: alpha(color, 0.12),
    };
  };

export const actionRow: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-end",
};

export const deleteRow: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(1.25),
  flexDirection: { xs: "column", md: "row" },
});

export const deleteRequested: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: { xs: "stretch", md: "center" },
  flexDirection: { xs: "column", md: "row" },
  gap: theme.spacing(1.25),
  fontSize: { xs: "0.71875rem", md: "0.78125rem" },
  color: "error.main",
  fontWeight: 600,
});

export const errorNote: SxProps<Theme> = (theme) => ({
  p: 1.5,
  borderRadius: 1.5,
  fontSize: "0.75rem",
  fontWeight: 600,
  color: theme.palette.error.main,
  bgcolor: alpha(theme.palette.error.main, 0.06),
  border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
});
